import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText } from "@mui/material";
import { VscMenu } from "react-icons/vsc";
import administrador from "./../assets/administrador.svg";
import myinventoryWhite from "./../assets/myinventory-white.svg";
import "./../styles/Drawer.css";

const DrawerNavigation = () => {
  const location = useLocation();
  const user = location.state?.user || localStorage.getItem('user');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <main>
        {user.roles !== "administrador" && (
          <button className="img-clicavel div-adm" onMouseEnter={toggleDrawer}>
                        <VscMenu className='menu-icone' onClick={() =>
                navigate("/myinventory/RelatorioAgendamentos", {
                  state: { user },
                })}></VscMenu>
            {/* <img
              // src={administrador}
              alt="Acesso do Administrador"
              title="Acesso do Administrador"
              onClick={() =>
                navigate("/myinventory/RelatorioAgendamentos", {
                  state: { user },
                })
              }
            /> */}
          </button>
        )}

        <Drawer open={isOpen} onClose={toggleDrawer}>
          <List className="Drawer">
            <img
              src={myinventoryWhite}
              alt="logo myinventory"
              className="myinventory-logo"
            />
            <ListItem
              button
              onClick={() =>
                navigate("/myinventory/PerfisDeUsuario", { state: { user } })
              }
            >
              {/* <img src={usuariosPermissao} className='img-clicavel-dentro-drawer' alt="Usuários" title='Perfis de Usuários'  /> */}
              <ListItemText primary="Criação de Usuários" />
            </ListItem>
            <ListItem
              button
              onClick={() =>
                navigate("/OpcoesDeAcesso", { state: { user } })
              }
            >
              <ListItemText primary="Opções De Acesso" />
            </ListItem>

            <ListItem
              button
              onClick={() =>
                navigate("/RelatorioAgendamentos", {
                  state: { user },
                })
              }
            >
              {/* <img src={relatorio} className='img-clicavel-dentro-drawer' alt="relatório" title='Relatório de Agendamentos'></img> */}
              <ListItemText primary="Relatórios" />
            </ListItem>




          </List>
        </Drawer>
      </main>
    </>
  );
};

export default DrawerNavigation;
